import { Component, OnInit } from "@angular/core";
import { LocalStorageService } from "ng2-webstorage";
import { NoticeboardService } from "../../../../../components/noticeboard/noticeboard/noticeboard.service";
import { initGoogleClient } from "../../../../../shared/googleAuth/googleAuthentication";
import { MessageService } from "primeng/components/common/messageservice";
import { DataAnalyticsService } from "../../../../../components/dataAnalytics/dataAnalytics.service";
declare var gapi: any;

@Component({
  selector: "addsubject",
  templateUrl: "addsubject.component.html",
  styleUrls: ["addsubject.component.scss"],
})
export class AddTSubjectQuantaComponent implements OnInit {
  public SchoolYear: any;
  public selectedYear: any;
  public ShowLevelData: any;
  public selectedlevel: string = '';
  public section: any;
  public selectedgrade:  any;
  public selectedTeacher:  any;
  public selectedsection:  any;
  public grade: any = [];
  selectedSubject: string = "All Subjects";
  subjects: any = [];
  subjectsList: any = [];
  public mappedData: any;
  nameofsec: any = [];
  sectionId: any = []
  sectionList: any = [];
  public TeacherDetailsData: any = [];
  public display;
  public schoolId: any;
  public selectedsub: any;
  public selectedsec: any;


 

  public selectedTitle: any;
  public enteredFirstName: string;
  public enteredLastName: string;
  public enteredMiddleName: string;
  public enteredEmail: string;
  public enteredPhone: string;

  constructor(
    private dataAnalyticsService: DataAnalyticsService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) {
    this.schoolId = this.localStorage.retrieve('schoolid');
    //this.userId = this.localStorage.retrieve('CurrentChildId');
  }
  ngOnInit() {
    this.getAcademicYear();
  }

  private getAcademicYear() {
    this.dataAnalyticsService
      .getAcadamicYearOfyears()
      .finally(() => {})
      .subscribe(
        (response) => {
          this.SchoolYear = response["yearList"];
          console.log("SchoolYear", this.SchoolYear);
          try {
            this.selectedYear = this.SchoolYear[0].YearId
            this.getTeacherDetails();
          } catch (error) {}
        },
        (error) => {
          this.SchoolYear = [];
          console.error(error);
        }
      );
  }
  changeYear(){
    console.log("selectedYear",this.selectedYear)

  }
//-----------------------------------------------------------------------------------------------------------

  /*private getTeacherDetails() {
    this.dataAnalyticsService
      .getTeacherDetails()
      ._finally(() => {})
      .subscribe((response) => {
        this.TeacherDetailsData = response["teacherdetailList"];
        console.log("getTeacherDetails", this.TeacherDetailsData);
        try {
          this.selectedTeacher = this.TeacherDetailsData[0].teacherid;
          this.getLevelsName();
        } catch (error) {}
      });
  }*/

  private getTeacherDetails() {
    this.dataAnalyticsService
      .getDropDownTeacherDetails()
      ._finally(() => {})
      .subscribe((response) => {
        this.TeacherDetailsData = response["Value"];
        console.log("getTeacherDetails", this.TeacherDetailsData);
        try {
          this.selectedTeacher = this.TeacherDetailsData[0].teacherid;
          this.getLevelsName();
        } catch (error) {}
      });
  }

  changeteacher(){
    console.log("selectedTeacher",this.selectedTeacher)
  }
  //------------------LEVEL Primary, secondary----------------------------------------------------------------


  private getLevelsName() {
    this.dataAnalyticsService
      .getLevel()
      ._finally(() => {})
      .subscribe((response) => {
        this.ShowLevelData = response;
        try {
          this.selectedlevel =  this.ShowLevelData[0].Id;
          //this.getClassSection(this.selectedlevel["Id"]);
          this.getLevelClassSection(this.selectedlevel);
        } catch (error) {

        }
        console.log("ShowLevelData", this.ShowLevelData);
    }, (error) => {

    });
  }

  getLevelsListById(){
    console.log("fffff", this.selectedlevel);
    this.getLevelClassSection(this.selectedlevel);
  }

  //------------------------Ex Grade 1,2,3, & A,B,C--------------------------------------------------------------

  private getLevelClassSection(lid) {
    this.dataAnalyticsService.GetLevelStandardSectionMapping(lid).finally(() => { }).subscribe(
      response => {
        let mappedData: any = response;
        mappedData.forEach(standard => {
          standard['Sections'].forEach(section => {
            section['StdId'] = standard['standardId'];
            section['StdName'] = standard['standardsName'];
            section['selected'] = false;
          });
        });
        console.log("mappedData", mappedData);
        mappedData.sort((a, b) => ("" + a.standardsName).localeCompare(b.standardsName, undefined, { numeric: true }));
        if (true) {
          this.mappedData = mappedData;

        }

        try {
            this.selectedgrade = mappedData[mappedData.length - 1];
            this.getSectionByGrade(this.selectedgrade);
            this.selectedsection = this.selectedgrade.Sections[0];
            this.getSubjects();
        } catch (error) {
          //window.location.reload();
        }

        try {
          this.nameofsec = this.selectedsection.sectionName;
          this.sectionId = this.selectedsection.SectionId;
        } catch (error) {

        }

    
      },
      error => {
          this.mappedData = [];
          this.sectionList = [];
          this.subjectsList = [];
          this.selectedgrade = null;
          this.selectedsection = null;
          this.selectedSubject = null;
      });
  };

  getSectionByGrade(grade) {
    this.subjectsList = [];
    this.selectedSubject = null;
    this.sectionList = grade.Sections;
    try {
        this.selectedsection = this.sectionList[0];
        this.getSubjects();
    } catch (error) {

    }
  }

getGclClassesListById(section) {
 
  this.nameofsec = section.sectionName;
  this.sectionId = section.SectionId;
  //this.getStudentData(this.standardId,section.SectionId,this.yearId)
  this.selectedsec = section.SectionId
  console.log('getGclClassesListById', this.selectedsec);

  this.getSubjects();
}
  /* -----------------------------GET SUBJECT--------------------------------*/
  
  getSubjects(){
    this.dataAnalyticsService.getSubjects(this.selectedsection.SectionId).finally(() => { }).subscribe(
    response => {
        let res: any = response;
        console.log("getSubjects", res);
        this.subjectsList = res.subsemList[0];
        try {
            this.selectedSubject = this.subjectsList[0];
        } catch (error) {

        }
    },
    error => {
        console.log("getSubjects error", error);
        this.subjectsList = [];
    });
  }

  onSelectedSubject(subject){
      this.selectedsub = subject.SubjectId;
      console.log("onSelectedSubject", this.selectedsub);
  }
/*------------------------------------------------------------------------------------------------------------------*/

postteachersubject() {
  
  var payload = {
    TeacherId: this.selectedTeacher,
    SubjectId: this.selectedsub,
    SectionId: this.selectedsec,
    CreatedBy: this.schoolId,
    ModifiedBy: this.schoolId,
    AcademicYearId: this.selectedYear
  };
  
  console.log("postteachersubject",payload);

  this.dataAnalyticsService
    .PostTeacherSubject(payload)
    .finally(() => {})
    .subscribe(
      (response) => {
        this.messageService.add({
          severity: "success",
          summary: "Talkative Parents",
          detail: "Teacher Subject Added Successfully",
        });
        this.display = "none";
        //this.getHigherEdChildBatch();
    
        console.log(response);
      },
      (error) => {}
    );
}}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/Teachers/addsubject.component.ts